import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const ExportPageWrapper = styled.div`
  width: 1100px;
  padding: 40px;
  background-color: #fff;
  position: fixed;
  left: 100vw;
  top: 0;
  display: flex;
  flex-direction: column;
  pointer-events: none;
  font-size: 1.2rem;

  p {
    margin: 0;
  }
`;

export const ModalBody = styled.div`
  padding: 2em 3em 1em 3em;

  ${mediaMaxWidth.phone} {
    padding: 1em;
  }
`;

export const CompanyName = styled.div`
  position: absolute;
  right: 40px;
  top: 0;
  font-style: italic;
`;

export const Column = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  ${mediaMaxWidth.phone} {
    width: 155px;
    margin: 0 auto;
  }
`;

export const FieldSet = styled.fieldset`
  display: flex;
  margin: 2rem auto 3em auto;

  ${mediaMaxWidth.phone} {
    flex-direction: column;
    align-items: center;
  }
`;

export const Title = styled.h1`
  margin: 60px 0 20px;
  font-weight: 800;
`;

export const Info = styled.div`
  display: flex;
`;

export const InfoLine = styled.p``;

export const SectionTitle = styled.h3`
  text-decoration: underline;
  font-style: italic;
  font-weight: 300;
  margin: 40px 0 10px 0;
`;

export const Note = styled.p`
  font-style: italic;
  font-size: ${({ theme }) => theme.fontSize.normal.desktop} !important;

  ${mediaMaxWidth.phone} {
    font-size: ${({ theme }) => theme.fontSize.normal.mobile} !important;
  }
`;
